/*Framework Imports */
import React, { useState } from 'react';
/*Css Imports*/
import './home.css';
/*Third Party Imports*/
import Form, { SimpleItem, GroupItem, ButtonItem, EmailRule, RequiredRule, PatternRule, CustomRule } from 'devextreme-react/form';
import Box, { Item } from 'devextreme-react/box';
import { Alert } from 'reactstrap';

/*Api Imports */
import registerApi from '../../infrastructure/registerapi';
import authenticationApi from '../../infrastructure/authenticationapi';
/*Utilities import */
import utilities from '../../infrastructure/utilities';
/*Tlds Imports */
import tlds from "../../data/tlds.json";

let countries = [];
let states = [];
let provinces = [];
let employmentTypes = [];
let roles = [];

/*Local Instances*/
const dynamicId=utilities.generateUUID();
let member={};
member["fistNameXYZ"+dynamicId]='';
member["lastNameXYZ"+dynamicId]='';
member["emailXYZ"+dynamicId]='';
member["phoneXYZ"+dynamicId]='';
member["countryXYZ"+dynamicId]='3a50053f-f6c7-4e7e-886d-297d2eb2f59a';
member["stateXYZ"+dynamicId]='';
member["employmentTypeXYZ"+dynamicId]='';
member["roleValueXYZ"+dynamicId]='00000000-0000-0000-0000-000000000000';
member["companyXYZ"+dynamicId]='';

/*Component Declaration*/
const Home = () => {
    /*Local state*/
    const [isLoading, setIsLoading] = useState(true);
    const [isCountriesLoaded, setIsCountryLoaded] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isCompany, setIsCompany] = useState(false);

    /*Event Handlers*/
    const onFieldDataChanged = (e) => {
        //Set form component
        window.formComponent = e.component;
        //Load countries
        if (e.component.getEditor("countryXYZ"+dynamicId).option("dataSource").length === 0) e.component.getEditor("country").option("dataSource", countries);

        if (e.dataField === "countryXYZ"+dynamicId) {
            e.component.getEditor("stateXYZ"+dynamicId).option("dataSource", e.value === "cbfa309d-e80f-4e3f-8985-aaadbfc33f38" ? provinces : states);
            e.component.updateData("stateXYZ"+dynamicId, "")
        }

        const res = e.component.validate();

        if (e.dataField === "employmentTypeXYZ"+dynamicId) {
            setIsCompany(prevState => (e.value === "d238cdd5-a5a7-4ee7-8289-30c1ee510489"));
            //Restart captcha
            if (res.isValid) window.reLoadCaptcha = true;
        }

        if (res.isValid) {
            document.getElementById("recaptcha").style.display = "block";
            if (window.recaptchaReady === true && window.recaptchaRendered === undefined) {
                // eslint-disable-next-line no-undef
                grecaptcha.enterprise.render('recaptcha', {
                    // eslint-disable-next-line no-undef
                    'sitekey': config.siteKey,
                    'callback': onRecaptchaDataCallback,
                    'expired-callback': onRecaptchaExpiredCallback,
                    'tabindex':10
                });
                window.recaptchaRendered = true;
            }
            if (window.recaptchaValidated === true && window.recaptchaToken !== undefined) {
                e.component.getButton("register").option("disabled", false);
            }
            else {
                e.component.getButton("register").option("disabled", true);
            }
        }
        else {
            //Only hide the first time
            if (window.recaptchaValidated === undefined && window.recaptchaToken !== undefined) {
                document.getElementById("recaptcha").style.display = "none";
            }
            e.component.getButton("register").option("disabled", true);
        }
    }

    const onRecaptchaDataCallback = (e) => {
        window.recaptchaValidated = true;
        window.recaptchaToken = e;
        if (window.formComponent !== undefined) {
            let eData = { dataField: "", component: window.formComponent };
            onFieldDataChanged(eData);
        }
    }

    const onRecaptchaExpiredCallback = (e) => {
        window.recaptchaValidated = undefined;
        window.recaptchaToken = undefined;
        if (window.formComponent !== undefined) {
            let eData = { dataField: "", component: window.formComponent };
            onFieldDataChanged(eData);
        }
    }

    const onContentReady = (e) => {
        //Initial authorize request
        if (isCountriesLoaded === false) {
            authenticationApi.auth().then(res => {

                registerApi.getCountriesStates().then(res => {
                    if (res !== undefined) {
                        countries = [];
                        res.data.filter(x => x.ParentObjectGuid === "00000000-0000-0000-0000-000000000000" && x.Active === true).sort((a, b) => a.Value < b.Value ? 1 : -1).forEach(item => {
                            countries.push({ id: item.Guid, text: item.Value });
                        });
                        /*states*/
                        res.data.filter(x => x.ParentObjectGuid === "3a50053f-f6c7-4e7e-886d-297d2eb2f59a" && x.Active === true).sort((a, b) => a.Value > b.Value ? 1 : -1).forEach(item => {
                            states.push({ id: item.Guid, text: item.Value });
                        });
                        /*provinces*/
                        res.data.filter(x => x.ParentObjectGuid === "cbfa309d-e80f-4e3f-8985-aaadbfc33f38" && x.Active === true).sort((a, b) => a.Value > b.Value ? 1 : -1).forEach(item => {
                            provinces.push({ id: item.Guid, text: item.Value });
                        });
                        /*get employment types */
                        registerApi.getEmploymentTypes().then(res => {
                            if (res !== undefined) {
                                employmentTypes = [];
                                res.data.filter(x => x.Active === true).sort((a, b) => a.Value < b.Value ? 1 : -1).forEach(item => {
                                    employmentTypes.push({ id: item.Guid, text: item.Value });
                                });
                                registerApi.getRoles().then(res => {
                                    if (res !== undefined) {
                                        roles = [];
                                        res.data.filter(x => x.Active === true).sort((a, b) => {
                                            /*sets 'Other' role to bottom of the list */
                                            if (a.Value === "Other") return 1;
                                            if (b.Value === "Other") return -1;
                                            return a.Value > b.Value ? 1 : -1;
                                        }).forEach(item => {
                                            roles.push({ id: item.Guid, text: item.Value });
                                        });
                                        setIsCountryLoaded(prevState => true);
                                        setIsLoading(prevState => false);
                                    }
                                });
                            }
                        });
                    }
                });
            });
        }

        e.component.validate();
        //Remove Flex from captcha field
        document.querySelector("#form > div > div > div > div:nth-child(2) > div > div:nth-child(1)").style.flex = "none";

        //Reload Captcha
        if (window.recaptchaReady === true && window.reLoadCaptcha === true) {
            setTimeout(() => {
                if (document.getElementById("recaptcha") !== null) {
                    document.getElementById("recaptcha").style.display = "block";
                    // eslint-disable-next-line no-undef
                    grecaptcha.enterprise.render('recaptcha', {
                        // eslint-disable-next-line no-undef
                        'sitekey': config.siteKey,
                        'callback': onRecaptchaDataCallback,
                        'expired-callback': onRecaptchaExpiredCallback,
                        'tabindex': 10
                    });
                    window.recaptchaRendered = true;
                    window.reLoadCaptcha = undefined;
                }
            }, 500);
            window.recaptchaToken = undefined;
            window.recaptchaValidated = undefined;
        }
    }

    const onSumbitButtonClick = (e) => {
        //Start loader
        setIsLoading(prevState => true);
        //Prevent default submit
        e.event.preventDefault();
        //Add recaptcha token
        if (window.recaptchaToken !== undefined) member.recaptchaToken = window.recaptchaToken;
        //Clean company and role if company is not selected
        if (member["employmentTypeXYZ"+dynamicId] !== "d238cdd5-a5a7-4ee7-8289-30c1ee510489") {
            member["companyXYZ"+dynamicId] = "";
            member["roleValueXYZ"+dynamicId] = "00000000-0000-0000-0000-000000000000";
        }
        //Users can type anything they want, only saves letters, numbers, and spaces into database
        member["companyXYZ"+dynamicId] = member["companyXYZ"+dynamicId].replace(/[^a-zA-Z0-9 ]/g, "");

        const newMember = {
            firstName: member["fistNameXYZ"+dynamicId],
            lastName: member["lastNameXYZ"+dynamicId],
            email: member["emailXYZ"+dynamicId],
            phone: member["phoneXYZ"+dynamicId],
            country: member["countryXYZ"+dynamicId],
            state: member["stateXYZ"+dynamicId],
            employmentType: member["employmentTypeXYZ"+dynamicId],
            role: member["roleValueXYZ"+dynamicId],
            company: member["companyXYZ"+dynamicId]
        };

        registerApi.registerMember(newMember, setIsLoading, setErrorMessage).then(res => {
            if (res !== undefined && res.data !== undefined) {
                setIsLoading(prevState => false);
                //Redirect to validate
                // eslint-disable-next-line no-undef
                window.location.href = config.baseUrl + "validate/" + res.data + "/" + member["emailXYZ"+dynamicId] + "/" + member["phoneXYZ"+dynamicId];
            } else {
                //Restart captcha
                window.reLoadCaptcha = true;
            }
        });
    }

    return (
        <div>
            {isLoading && <div className="loading">Loading</div>}
            <Box
                direction="row"
                width="100%"
            >
                <Item ratio={0.05}>
                </Item>
                <Item ratio={2}>
                    <h1 className="dx-form-group-caption dx-widget">Onboarding</h1>
                    <Form id="form"
                        formData={member}
                        onFieldDataChanged={onFieldDataChanged}
                        onContentReady={onContentReady}
                        validationGroup="onBoardingData"
                        colCount={2}
                        elementAttr={{ autocomplete: 'off' }}
                        labelLocation='top'
                        labelMode='outside'
                    >
                        <GroupItem
                            colSpan={2}
                        >
                            <SimpleItem dataField={"employmentTypeXYZ"+dynamicId} label={{ text: "Which employment type are you registering for?" }}
                                editorType={"dxSelectBox"}
                                editorOptions={{
                                    dataSource: employmentTypes,
                                    valueExpr: "id",
                                    displayExpr: "text",
                                    searchEnabled: false,
                                    inputAttr: { autocomplete: 'randomvalue', style:'font-size:16px' }
                                }
                                }
                            >
                                <RequiredRule message="Employment Type is required" />
                            </SimpleItem>

                            {isCompany === true &&
                                <SimpleItem dataField={"companyXYZ"+dynamicId} editorOptions={{ valueChangeEvent: "change keyup", inputAttr: { autocomplete: 'randomvalue', style:'font-size:16px' } }} label={{ text: "Company Name" }} >
                                <RequiredRule message="Company Name is required" />
                                </SimpleItem>
                            }
                            {isCompany === true &&
                                <SimpleItem dataField={"roleValueXYZ"+dynamicId} label={{ text: "Select the role you hold in your company" }} editorType={"dxSelectBox"} editorOptions={{ dataSource: roles, valueExpr: "id", displayExpr: "text", inputAttr: { autocomplete: 'randomvalue', style:'font-size:16px' }}} >
                                </SimpleItem>
                            }
                            <SimpleItem label={{ text: "First Name" }} dataField={"fistNameXYZ"+dynamicId} editorOptions={{ valueChangeEvent: "change keyup", label:"First Name", inputAttr: { autocomplete: 'randomvalue', style:'font-size:16px' } }} >
                                <RequiredRule message="First Name is required" />
                                <PatternRule pattern={/^[a-zA-Z-'']*$/} message="Valid First Name can only include letters, hyphens, and apostrophes" />
                            </SimpleItem>
                            <SimpleItem label={{ text: "Last Name" }} dataField={"lastNameXYZ"+dynamicId} editorOptions={{ valueChangeEvent: "change keyup", inputAttr: { autocomplete: 'new-lastname' , style:'font-size:16px' } }} >
                                <RequiredRule message="Last Name is required" />
                                <PatternRule pattern={/^[a-zA-Z-'']*$/} message="Valid Last Name can only include letters, hyphens, and apostrophes" />
                            </SimpleItem>
                            <SimpleItem label={{ text: "Email" }} dataField={"emailXYZ"+dynamicId} editorOptions={{ mode:'email', valueChangeEvent: "change keyup", inputAttr: { autocomplete: 'new-email' , style:'font-size:16px' } }} >
                                <EmailRule message="Email is invalid" />
                                <RequiredRule message="Email is required" />
                                <CustomRule message="The email address you entered appears to be invalid. Please review it." 
                                validationCallback={ event => {
                                    const email = event.value;
                                    const pattern = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/
                                    if (!email.match(pattern)) {
                                        return false; 
                                    }
                                    const emailTld = email.split('.').pop().toLowerCase();
                                    return tlds.map(tld => tld.toLowerCase()).includes(emailTld);
                                }}
                                />

                            </SimpleItem>
                            <SimpleItem dataField={"phoneXYZ"+dynamicId}
                                label={{ text: "Cell Phone" }}
                                editorOptions={{
                                    mask: '(000) 000-0000',
                                    maskInvalidMessage: 'The cell phone must have a correct phone format',
                                    valueChangeEvent: "change keyup",
                                    inputAttr: { autocomplete: 'randomvalue', style:'font-size:16px' },
                                    mode : 'tel'  
                                }}
                            >
                                <PatternRule
                                    message="The phone must have a correct phone format"
                                    pattern={/^[0-9]\d{9}$/}
                                />
                                <RequiredRule message="Cell Phone is Required" />
                            </SimpleItem>
                            <SimpleItem label={{ text: "Country" }} dataField={"countryXYZ"+dynamicId}
                                editorType={"dxSelectBox"}
                                editorOptions={{
                                    dataSource: countries,
                                    valueExpr: "id",
                                    displayExpr: "text",
                                    value: "3a50053f-f6c7-4e7e-886d-297d2eb2f59a",
                                    inputAttr: { autocomplete: 'randomvalue', style:'font-size:16px' }
                                }
                                }
                            >
                                <RequiredRule message="Country is Required" />
                            </SimpleItem>
                            <SimpleItem dataField={"stateXYZ"+dynamicId} label={{ text: "State/Province" }}
                                editorType={"dxSelectBox"}
                                editorOptions={{
                                    dataSource: states,
                                    valueExpr: "id",
                                    displayExpr: "text",
                                    searchEnabled: true,
                                    acceptCustomValue: true,
                                    searchExpr: "text",
                                    searchMode: "startswith",
                                    inputAttr: { autocomplete: 'off', style:'font-size:16px' },
                                    onFocusIn: function(event) {
                                        event.event.target.select();
                                      }
                                }
                                }
                            >
                                <RequiredRule message="State is Required" />
                            </SimpleItem>
                        </GroupItem>
                        <SimpleItem colSpan={1}
                            render={() => <div id="recaptcha" className="recaptcha"></div>}
                        />
                        <ButtonItem colSpan={1} name="register" horizontalAlignment="left"
                            verticalAlignment="center" elementAttr={{ class: "btnCustom" }}
                            buttonOptions={{
                                text: 'Register',
                                type: 'success',
                                useSubmitBehavior: true,
                                disabled: true,
                                onClick: onSumbitButtonClick
                            }}
                        />
                    </Form>
                    {errorMessage !== "" &&
                        <Alert color="danger">
                            <h4>{errorMessage}</h4>
                        </Alert>}
                </Item>
                <Item ratio={0.05}>
                </Item>
            </Box>
        </div>
    );
}

/*Component Export*/
export default Home;